import * as React from 'react';
import { Box, Container, CssBaseline, Divider, IconButton, Snackbar, Alert, Collapse
  , List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography, Tooltip, Hidden } from "@mui/material";
import MuiDrawer from '@mui/material/Drawer';
import { styled, useTheme } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import { Menu as MenuIcon, Inbox as InboxIcon, Person as PersonIcon, RecordVoiceOver as RecordVoiceOverIcon
  , EmojiPeople as EmojiPeopleIcon, ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon
  , CalendarMonth as CalendarMonthIcon, AssignmentInd as AssignmentIndIcon, EscalatorWarning as EscalatorWarningIcon
  , ContentPasteSearch as ContentPasteSearchIcon, Badge as BadgeIcon, AddCard as AddCardIcon, NoteAlt as NoteAltIcon
  , Calculate as CalculateIcon, BarChart as BarChartIcon, List as ListIcon
  , Logout as LogoutIcon, Block as BlockIcon, DoneAll as DoneAllIcon
  , ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon
  , Settings as SettingsIcon, School as SchoolIcon, Timeline as TimelineIcon, MonitorHeart as MonitorHeartIcon } from "@mui/icons-material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import useMediaQuery from "@mui/material/useMediaQuery";

import { BrowserRouter as Router, Link, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { registerShowMessage } from "./services/notificationService";
import { cerrarSesion, obtenerUsuario } from "./services/authService";
import RutaProtegida from "./components/RutaProtegida";
import PerfilUsuario from "./components/PerfilUsuario";
import Login from "./containers/Login/Index";
import Person from "./containers/Person/Index";
import Model from "./containers/Model/Index";
import PersonEdit from "./containers/Person/Edit";
import PersonEditLegal from "./containers/Person/EditLegal.js";
import Member from "./containers/Member/Index";
import MemberEdit from "./containers/Member/Edit";
import Therapy from './containers/Therapy/Index';
import TherapyEdit from './containers/Therapy/Edit';
import TherapyPlan from './containers/TherapyPlan/Index';
import TherapyPlanEdit from './containers/TherapyPlan/Edit';
import TherapyPeriod from './containers/TherapyPeriod/Index';
import Period from './containers/Period/Index';
import PeriodEdit from './containers/Period/Edit';
import TherapyPeriodOpen from './containers/TherapyPeriod/Open';
import TherapyPeriodPayment from './containers/TherapyPeriod/Payment';
import TherapyPeriodPaymentEdit from './containers/TherapyPeriod/PaymentEdit';
import SecurityUser from './containers/Security/User';
import SecurityUserEdit from './containers/Security/UserEdit';
import SecurityRole from './containers/Security/Role';
import SecurityRoleEdit from './containers/Security/RoleEdit';
import SecurityAccess from './containers/Security/Access';
import Authorization from './containers/Authorization/Index';
import SessionTherapist from './containers/Session/IndexTherapist';
import SessionEdit from './containers/Session/Edit';
import Session from './containers/Session/Index';
import useWindowSize from './components/useWindowSize';
import InvoiceItem from './containers/InvoiceItem/Index';
import InvoiceItemEdit from './containers/InvoiceItem/Edit';
import Receipt from './containers/Receipt/Index';
import ReceiptEdit from './containers/Receipt/Edit';
import ReceiptPayment from './containers/Receipt/Payment';
import ReceiptAnularPago from './containers/Receipt/AnularPago';
import ReceiptConsolidarPagos from './containers/Receipt/ConsolidarPagos';
import ReceiptPrint from './containers/Receipt/Print';
import Catalog from './containers/Catalog/Index';
import CatalogEdit from './containers/Catalog/Edit';
import Trabajador from './containers/Trabajador/Index';
import TrabajadorEdit from './containers/Trabajador/Edit';

const drawerOpenWidth = 240;
const drawerClosedWidth = 64;

const openedMixin = (theme) => ({
  width: drawerOpenWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 3,
  // zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // ...(open && {
  //   marginLeft: drawerWidth,
  //   width: `calc(100% - ${drawerWidth}px)`,
  //   transition: theme.transitions.create(['width', 'margin'], {
  //     easing: theme.transitions.easing.sharp,
  //     duration: theme.transitions.duration.enteringScreen,
  //   }),
  // }),
}));

// const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
//   ({ theme, open }) => ({
//     width: drawerWidth,
//     flexShrink: 0,
//     whiteSpace: 'nowrap',
//     boxSizing: 'border-box',
//     ...(open && {
//       ...openedMixin(theme),
//       '& .MuiDrawer-paper': openedMixin(theme),
//     }),
//     ...(!open && {
//       ...closedMixin(theme),
//       '& .MuiDrawer-paper': closedMixin(theme),
//     }),
//   }),
// );

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "expanded",
})(({ theme, expanded }) => ({
  width: expanded ? drawerOpenWidth : drawerClosedWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  position: "fixed",
  zIndex: theme.zIndex.drawer,

  "& .MuiDrawer-paper": {
    position: "fixed",
    width: expanded ? drawerOpenWidth : drawerClosedWidth,
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: expanded
        ? theme.transitions.duration.enteringScreen
        : theme.transitions.duration.leavingScreen,
    }),
    zIndex: theme.zIndex.drawer,
  },
}));

function Layout() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const drawerVisible = isDesktop || open;
  const drawerExpanded = isDesktop && open;
  // El panel del menu muestra los titulos cuando esta abierto: en escritorio,
  // cuando el menu esta desplegado; en movil, cuando se abre con el boton.
  const menuAncho = drawerVisible && open;

  const navigate = useNavigate();
  const usuario = obtenerUsuario();

  const salir = () => {
    cerrarSesion();
    navigate("/login", { replace: true });
  };

  React.useEffect(() => {
    if (!isDesktop) {
      setOpen(false);
    }
  }, [isDesktop]);

  const handleMenuItemClick = () => {
    if (!isDesktop) {
        setOpen(false);
    }
  };
  
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  // El menu sigue el proceso de las terapias: primero se parametriza, luego se
// registran las personas, los modelos de intervencion, las terapias con su
// plan y sus periodos, las sesiones que el terapeuta registra y, al final, la
// facturacion con sus pagos.
const navGroups = [
    {
      title: "Inicio",
      path: "/",
      icon:
      <Tooltip title="Inicio" placement="right-end">
        <InboxIcon aria-label="Inicio" />
      </Tooltip>
    },
    {
      title: "Personas",
      icon:
      <Tooltip title="Personas" placement="right-end">
        <PersonIcon aria-label="Personas" />
      </Tooltip>,
      children: [
        {
          title: "Personas",
          path: "/person",
        },
        {
          title: "Participantes",
          path: "/member",
        },
      ]
    },
    {
      title: "Modelos",
      icon:
      <Tooltip title="Modelos de Terapia" placement="right-end">
        <SchoolIcon aria-label="Modelos de Terapia" />
      </Tooltip>,
      children: [
        {
          title: "Modelos de Terapia",
          path: "/model",
        },
      ]
    },
    {
      title: "Proceso de Terapias",
      icon:
      <Tooltip title="Proceso de Terapias" placement="right-end">
        <TimelineIcon aria-label="Proceso de Terapias" />
      </Tooltip>,
      children: [
        {
          title: "Terapias",
          path: "/therapy",
        },
        {
          title: "Planes de Terapia",
          path: "/therapyplan",
        },
        {
          title: "Periodos de Terapias",
          path: "/therapyPeriod",
        },
        {
          title: "Pagos de Periodos",
          path: "/therapyperiod/pago",
        },
      ]
    },
    {
      title: "Sesiones",
      icon:
      <Tooltip title="Sesiones" placement="right-end">
        <MonitorHeartIcon aria-label="Sesiones" />
      </Tooltip>,
      children: [
        {
          title: "Sesiones de Terapeuta",
          path: "/session/24",
        },
        {
          title: "Sesiones",
          path: "/session",
        },
      ]
    },
    {
      title: "Facturacion",
      icon:
      <Tooltip title="Facturacion" placement="right-end">
        <ContentPasteSearchIcon aria-label="Facturacion" />
      </Tooltip>,
      children: [
        {
          title: "Comprobantes",
          path: "/receipt",
        },
        {
          title: "Anular Pagos",
          path: "/receipt/pago/anular",
        },
        {
          title: "Consolidar Pagos",
          path: "/receipt/pago/consolidar",
        },
      ]
    },
    {
      title: "Configuracion",
      icon:
      <Tooltip title="Configuracion" placement="right-end">
        <SettingsIcon aria-label="Configuracion" />
      </Tooltip>,
      children: [
        {
          title: "Catalogos",
          path: "/catalog",
        },
        {
          title: "Personal",
          path: "/trabajador",
        },
        {
          title: "Conceptos de Cobro",
          path: "/invoiceItem",
        },
        {
          title: "Periodos",
          path: "/period",
        },
        {
          title: "Usuarios",
          path: "/security/user",
        },
        {
          title: "Roles",
          path: "/security/role",
        },
        {
          title: "Accesos",
          path: "/security/access",
        },
        {
          title: "Autorizaciones",
          path: "/authorization",
        },
      ]
    },
  ]

  // El grupo de la pantalla abierta queda desplegado, para no perder de vista
  // en que parte del menu se esta trabajando.
  const location = useLocation();

  const grupoDeRuta = (pathname) => navGroups.find((grupo) =>
    (grupo.path && grupo.path === pathname)
    || (grupo.children || []).some((item) => pathname === item.path || pathname.indexOf(item.path + "/") === 0)
  );

  const [gruposAbiertos, setGruposAbiertos] = React.useState({});

  React.useEffect(() => {
    const grupo = grupoDeRuta(location.pathname);
    if (!grupo) return;

    setGruposAbiertos((previos) => ({ ...previos, [grupo.title]: true }));
  }, [location.pathname]);

  const toggleGrupo = (titulo) => {
    // Con el menu reducido solo el icono se ve: la primera pulsacion abre el
    // menu y deja el grupo desplegado.
    if (!menuAncho) {
      setOpen(true);
      setGruposAbiertos((previos) => ({ ...previos, [titulo]: true }));
      return;
    }

    setGruposAbiertos((previos) => ({ ...previos, [titulo]: !previos[titulo] }));
  }

  return (
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <AppBar position="fixed">
            <Toolbar>
              <IconButton
                color="inherit"
                edge="start"
                onClick={() => {
                  console.log("clicked menu");
                  setOpen(prev => !prev);
                }}
                sx={{ marginRight: 5 }}
              >
                {drawerExpanded ? <ChevronLeftIcon /> : <MenuIcon />}
              </IconButton>
              {/* <IconButton
                color="inherit"
                edge="start"
                onClick={() => {
                  if (open) {
                    handleDrawerClose();
                  } else {
                    handleDrawerOpen();
                  }
                }}
                sx={{ marginRight: 5 }}
              >
                {open ? <ChevronLeftIcon /> : <MenuIcon />}
              </IconButton> */}
              {/* <IconButton
                color="inherit"
                edge="start"
                onClick={handleDrawerOpen}
                sx={{
                  marginRight: 5,
                  ...(open && { display: 'none' }),
                }}
              >
                <MenuIcon />
              </IconButton> */}
              <Typography variant="h6" sx={{flexGrow: 1}}>
                Sistema Terapeutico
              </Typography>
              {usuario && <PerfilUsuario usuario={usuario} />}
              <Tooltip title="Cerrar sesión">
                <IconButton color="inherit" onClick={salir} aria-label="Cerrar sesión">
                  <LogoutIcon />
                </IconButton>
              </Tooltip>
            </Toolbar>
          </AppBar>
          {drawerVisible && (
          <ClickAwayListener
            onClickAway={() => {
              if (!isDesktop && open) {
                setOpen(false);
              }
            }}
          >
            <Box>
          <Drawer
            variant="permanent"
            expanded={menuAncho}
            sx={{ display: { xs: open ? "block" : "none", md: "block" } }}
          >
            <DrawerHeader>
              <IconButton
                color="inherit"
                edge="start"
                onClick={() => setOpen(prev => !prev)}
                sx={{ marginRight: 5 }}
              >
                {open ? <ChevronLeftIcon /> : <MenuIcon />}
              </IconButton>
            </DrawerHeader>
            <Divider />
              <List>
                {navGroups.map((grupo) => {
                  const desplegado = gruposAbiertos[grupo.title] === true;

                  // Opcion simple: navega directo.
                  if (!grupo.children) {
                    return (
                      <ListItem
                        key={grupo.title}
                        disablePadding
                        sx={{ display: "block" }}
                        style={{ color: "black" }}
                      >
                        <ListItemButton
                          component={Link}
                          to={grupo.path}
                          selected={location.pathname === grupo.path}
                          onClick={handleMenuItemClick}
                          sx={{
                            minHeight: 48,
                            justifyContent: menuAncho ? "initial" : "center",
                            px: 2.5,
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: menuAncho ? 3 : "auto",
                              justifyContent: "center",
                            }}
                          >
                            {grupo.icon}
                          </ListItemIcon>
                          <ListItemText
                            primary={grupo.title}
                            sx={{
                              opacity: menuAncho ? 1 : 0,
                              display: menuAncho ? "block" : "none",
                              whiteSpace: "nowrap"
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  }

                  // Grupo: el encabezado despliega sus opciones hacia abajo.
                  return (
                    <ListItem key={grupo.title} disablePadding sx={{ display: "block" }}>
                      <ListItemButton
                        onClick={() => toggleGrupo(grupo.title)}
                        sx={{
                          minHeight: 48,
                          justifyContent: menuAncho ? "initial" : "center",
                          px: 2.5,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: menuAncho ? 3 : "auto",
                            justifyContent: "center",
                          }}
                        >
                          {grupo.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={grupo.title}
                          sx={{
                            opacity: menuAncho ? 1 : 0,
                            display: menuAncho ? "block" : "none",
                            whiteSpace: "nowrap"
                          }}
                        />
                        {menuAncho && (
                          <IconButton
                            size="small"
                            aria-label={desplegado ? "ocultar " + grupo.title : "mostrar " + grupo.title}
                            onClick={(event) => {
                              event.stopPropagation();
                              toggleGrupo(grupo.title);
                            }}
                          >
                            {desplegado ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                          </IconButton>
                        )}
                      </ListItemButton>
                      <Collapse in={desplegado && menuAncho} timeout="auto" unmountOnExit>
                        <List disablePadding>
                          {grupo.children.map((item) => (
                            <ListItem key={item.title} disablePadding sx={{ display: "block" }}>
                              <ListItemButton
                                component={Link}
                                to={item.path}
                                selected={location.pathname === item.path}
                                onClick={handleMenuItemClick}
                                sx={{
                                  minHeight: 38,
                                  py: 0,
                                  pl: 6,
                                  justifyContent: "flex-start",
                                }}
                              >
                                <ListItemText
                                  primary={item.title}
                                  primaryTypographyProps={{ fontSize: 14 }}
                                  sx={{ whiteSpace: "nowrap" }}
                                />
                              </ListItemButton>
                            </ListItem>
                          ))}
                        </List>
                      </Collapse>
                    </ListItem>
                  );
                })}
              </List>
            <Divider />
          </Drawer>
          </Box>
          </ClickAwayListener>
          )}
          <Box component="main" sx={{ flexGrow: 1, paddingTop: 2, paddingLeft: 0, paddingRight: 0,
            ml: {
              xs: 0,
              md: menuAncho ? `${drawerOpenWidth}px` : `${drawerClosedWidth}px`,
            },
            transition: "margin-left 0.3s ease",
          }}>
          {/* <Box component="main" sx={{ flexGrow: 1, paddingTop: 2, paddingLeft: 0, paddingRight: 0 }}> */}
            <DrawerHeader />
            <Container>
              <Routes>
                <Route path="/contactanos"></Route>
                <Route path="/person" element={<Person />} ></Route>
                <Route path="/person/edit/:id/:idPersona/:idTipoPersona" element={<PersonEdit />}></Route>
                <Route path="/person/editLegal/:id" element={<PersonEditLegal />}></Route>
                <Route path="/model" element={<Model />} ></Route>
                <Route path="/member" element={<Member />} ></Route>
                <Route path="/member/edit/:id" element={<MemberEdit />}></Route>
                <Route path="/therapy" element={<Therapy />} ></Route>
                <Route path="/therapy/edit/:id" element={<TherapyEdit />} ></Route>
                <Route path="/therapyplan" element={<TherapyPlan />} ></Route>
                <Route path="/therapyplan/edit/:id/:idTerapia" element={<TherapyPlanEdit />} ></Route>
                <Route path="/period" element={<Period />} ></Route>
                <Route path="/period/edit/:id" element={<PeriodEdit />} ></Route>
                <Route path="/therapyPeriod" element={<TherapyPeriod />} ></Route>
                <Route path="/therapyPeriod/open" element={<TherapyPeriodOpen />} ></Route>
                <Route path="/therapyperiod/pago" element={<TherapyPeriodPayment />} ></Route>
                <Route path="/therapyperiod/pago/edit/:id/:numero" element={<TherapyPeriodPaymentEdit />} ></Route>
                <Route path="/security/user" element={<SecurityUser />} ></Route>
                <Route path="/security/user/edit/:id" element={<SecurityUserEdit />} ></Route>
                <Route path="/security/role" element={<SecurityRole />} ></Route>
                <Route path="/security/role/edit/:id" element={<SecurityRoleEdit />} ></Route>
                <Route path="/security/access" element={<SecurityAccess />} ></Route>
                <Route path="/authorization" element={<Authorization />} ></Route>
                <Route path="/session" element={<Session />} ></Route>
                <Route path="/session/:id" element={<SessionTherapist />} ></Route>
                <Route path="/session/edit/:id/:idTerapiaPeriodo" element={<SessionEdit />} ></Route>
                <Route path="/invoiceItem" element={<InvoiceItem />} ></Route>
                <Route path="/invoiceItem/edit/:id" element={<InvoiceItemEdit />} ></Route>
                <Route path="/receipt" element={<Receipt />} ></Route>
                <Route path="/receipt/edit/:id" element={<ReceiptEdit />} ></Route>
                <Route path="/receipt/pago" element={<ReceiptPayment />} ></Route>
                <Route path="/receipt/pago/:id" element={<ReceiptPayment />} ></Route>
                <Route path="/receipt/pago/anular" element={<ReceiptAnularPago />} ></Route>
                <Route path="/receipt/pago/consolidar" element={<ReceiptConsolidarPagos />} ></Route>
                <Route path="/receipt/print/:id" element={<ReceiptPrint />} ></Route>
                <Route path="/catalog" element={<Catalog />} ></Route>
                <Route path="/catalog/edit/:id" element={<CatalogEdit />} ></Route>
                <Route path="/trabajador" element={<Trabajador />} ></Route>
                <Route path="/trabajador/edit/:id" element={<TrabajadorEdit />} ></Route>
                <Route path="/nosotros"></Route>
                <Route path="/"></Route>
              </Routes>
            </Container>
          </Box>
        </Box>
  );
}

function App() {
  const [openMessage, setOpenMessage] = React.useState(false);
  const [propsMessage, setPropsMessage] = React.useState({
      severity: "info",
      message: ""
  });

  const onCloseMessage = () => {
    setOpenMessage(false);
  };

  React.useEffect(() => {
    registerShowMessage((messageData) => {
        setPropsMessage(messageData);
        setOpenMessage(true);
    });
  }, []);

  return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={<RutaProtegida><Layout /></RutaProtegida>} />
        </Routes>
        <Snackbar
            open={openMessage}
            autoHideDuration={5000}
            onClose={onCloseMessage}
            anchorOrigin={{
                vertical: "top",
                horizontal: "center"
            }}
        >
            <Alert
                onClose={onCloseMessage}
                severity={propsMessage.severity}
            >
                {propsMessage.message}
            </Alert>
        </Snackbar>
      </Router>
  );
}

export default App;
